// libs
import React, { useEffect } from "react";

// global components
import RouteChunkRenderer from "shared/components/RouteChunkRenderer";
import ChunkFallback from "shared/components/ChunkFallback";

// components
import HomePageMobile from "shared/layouts/Homepage/HomePageMobile";
import HomePageDesktop from "shared/layouts/Homepage/HomePageDesktop";

function HomePage() {
    useEffect(() => {
        // Attached TODO

        return () => {
            //@ts-ignore
            if (window.Verloop !== undefined) {
                //@ts-ignore
                window.Verloop.livechat.stop();
            }
        };
    }, []);

    return (
        <RouteChunkRenderer
            mobileComponent={<HomePageMobile fallback={<ChunkFallback />} />}
            desktopComponent={<HomePageDesktop fallback={<ChunkFallback />} />}
        />
    );
}

export default HomePage;
